import styled from 'styled-components';

export const Title = styled.div`
  color: var(--colorBlueGray600);
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const AddCard = styled.div<{ withImage: boolean }>`
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
  background-color: var(--colorWhite);
  border: 1px solid rgb(213, 215, 216);
  border-radius: 4px;
  height: 122px;
  width: 184px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
  }

  &:focus {
    border-color: var(--colorBlueGray1200);
    outline: none;
  }
`;

export const AddWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 38px 24px 31px;
`;

export const CardText = styled.div`
  color: var(--colorBlueGray400);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  text-align: center;
`;

export const CardWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  svg {
    cursor: pointer;
    color: var(--colorBlueGray600);
    width: 24px;
    height: 24px;
  }
`;

export const DeleteIconWrapper = styled.button`
  cursor: pointer;
  height: 24px;
  border: none;

  svg {
    transition: fill 0.2s ease-in-out;
  }

  &:focus,
  &:hover {
    outline: none;

    svg {
      fill: var(--colorBlueGray1200);
    }
  }
`;
